export const isValidJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const processFileExtension = (filename) => {
  if (!filename.includes(".")) return "none";

  const extension = filename.toLowerCase().split(".").pop();
  const extensionMap = {
    docx: "doc",
    doc: "doc",
    csv: "xls",
    xlsx: "xls",
    xls: "xls",
    pdf: "pdf",
    png: "jpg",
    jpg: "jpg",
    jpeg: "jpg",
    pptx: "pptx",
    zip: "zip",
  };

  return extensionMap[extension] || "none";
};



// WEBPACK FOOTER //
// ./src/components/Common/helperFunctions.js